module.exports = __webpack_public_path__ + "static/media/03-calendar.99238f8f.png";